import React, {Component} from 'react';
 
class CriteriaPlanGroup extends Component {
    constructor (props) {
        super(props);
        this.state = {}
    }
 
    render() {
        const { criterion, count } = this.props;
        return (
            <div className="ManagePlanCriterion GroupHeader">
                    <div className="MPDescription">
                        <span className="MPDescription__title">
                            {criterion.concept} - {criterion.parent_code}
                        </span>
                        <span className={`MPDescription__meta ${(count.currentActive < count.required?'Alert':'')}`} >
                           {(criterion.grouping ? `${criterion.grouping} of ${this.props.count.count} are required`: `All items in this group are required.`)}
                        </span>
                    </div>
                </div>
        )
    }
}
 
export default CriteriaPlanGroup;	